import React, { useCallback, useContext, useEffect, useState } from "react";
import {
  Button,
  DatePicker,
  Form,
  Input,
  Modal,
  Space,
  Table,
  Tooltip,
} from "antd";
import axios from "axios";
import moment from "moment";
// import { NotificationInfo, UserInfo } from "../../../../context";
import {
  AuditOutlined,
  CalendarOutlined,
  InfoCircleOutlined,
  CarOutlined,
  ArrowRightOutlined,
} from "@ant-design/icons";
import MerchantInvoiceDetails from "./MerchantInvoiceDetails";
import MerchantPaymentDetails from "../../../commissary/delivery/merchant-order/MerchantPaymentDetails";
import DeliveryFullDetails from "./DeliveryFullDetails";
import { UserInfo, NotificationInfo } from "../../../../context";

const MerchantDeliveryFromSupplier = () => {
  const [merchantOrderSaveList, setMerchantOrderSaveList] = useState({
    data: [],
    ready: false,
  });
  const tableLayout = "";
  const scroll = {};
  const { userData } = useContext(UserInfo);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [openFilterByDate, setOpenFilterByDate] = useState(false);
  const { rerunNotif } = useContext(NotificationInfo);
  const [openDrawerPayment, setOpenDrawerPayment] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [arriveDialog, setArriveDialog] = useState(false);
  const [search, setSearch] = useState("");
  const [selectedDisplay, setSelectedDisplay] = useState("groupby");

  const tableProps = {
    bordered: false,
    loading,
    size: "medium",
    // expandable,
    showHeader: true,
    scroll,
    tableLayout,
  };

  const columns = [
    {
      title: "Invoice Date",
      dataIndex: "invoice_date",
      // sorter: (a, b) => a.dr_date - b.dr_date,
      render: (date) => (
        <p>{moment(new Date(date), "YYYY-MM-DD").format("MMMM DD, YYYY")}</p>
      ),
    },
    {
      title: "PO Number",
      dataIndex: "po_number",
      // sorter: (a, b) => a.po_number - b.po_number,
      render: (text, record) => (
        <p
          style={{
            // textTransform: "uppercase",
            fontWeight: "bold",
            // color: "blue",
          }}
          // onClick={() => console.log("record", record)}
        >
          {text}
        </p>
      ),
    },
    {
      title: "Invoice Number",
      dataIndex: "invoice_number",
      // sorter: (a, b) => a.invoice_number - b.invoice_number,
      render: (text, record) => (
        <p
          style={{
            // textTransform: "uppercase",
            fontWeight: "bold",
            // color: "blue",
          }}
          onClick={() => console.log("record", record)}
        >
          {text}
        </p>
      ),
    },
    {
      title: "Payment Status",
      // dataIndex: "invoice_number",
      // sorter: (a, b) => a.dr_number - b.dr_number,
      align: "center",
      render: (text, record) => (
        <p
          style={{
            color:
              parseInt(text.payment_status) === 0
                ? "red"
                : parseInt(text.payment_status) === 1
                ? "green"
                : "orange",
            fontWeight: "bold",
          }}
        >
          {parseInt(text.payment_status) === 0
            ? "Unpaid"
            : parseInt(text.payment_status) === 1
            ? "Paid"
            : "Pending"}
        </p>
      ),
    },
    // {
    //   title: "Delivery Status",
    //   // dataIndex: "invoice_number",
    //   // sorter: (a, b) => a.dr_number - b.dr_number,
    //   align: "center",
    //   render: (text, record) => (
    //     <p>
    //       {text.deliverysavepoorder !== null
    //         ? text.deliverysavepoorder.po_status === "new"
    //           ? "P.O Placed"
    //           : text.deliverysavepoorder.po_status === "acknowledge"
    //           ? "Acknowledged"
    //           : text.deliverysavepoorder.po_status === "preparing"
    //           ? "Preparing"
    //           : text.deliverysavepoorder.po_status === "ready"
    //           ? "Ready To Deliver"
    //           : text.deliverysavepoorder.po_status === "in-transit"
    //           ? "In Transit"
    //           : text.deliverysavepoorder.po_status === "arrived"
    //           ? "Arrived"
    //           : "Completed"
    //         : ""}
    //     </p>
    //   ),
    // },
    {
      title: "",
      dataIndex: "",
      align: "center",
      render: (text) => (
        <p style={{ width: window.innerWidth > 575 ? "auto" : 90 }}>
          {text.deliverysavepoorder !== null &&
            text.deliverysavepoorder.po_status === "in-transit" &&
            parseInt(text.status) === 0 && (
              <Tooltip title="Set Arrived">
                <Button
                  type="dashed"
                  shape="circle"
                  onClick={() => {
                    setSelectedData(text);
                    setArriveDialog(true);
                  }}
                  icon={<CarOutlined />}
                  style={{ marginRight: 5 }}
                />
              </Tooltip>
            )}

          <Tooltip title="Details">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setSelectedData(text);
                setOpenDrawer(true);
              }}
              icon={<AuditOutlined />}
              style={{ marginRight: 5 }}
            />
          </Tooltip>

          {parseInt(text.payment_status) === 1 && (
            <Tooltip title="Payment Details">
              <Button
                type="dashed"
                shape="circle"
                onClick={() => {
                  setSelectedData(text);
                  setOpenDrawerPayment(true);
                }}
                icon={<InfoCircleOutlined />}
              />
            </Tooltip>
          )}
        </p>
      ),
    },
  ];

  const tableColumns = columns.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  const getMerchantOrderSaveList = useCallback(() => {
    var params = { user_id: userData.data.id };
    axios
      .get("user/merchant/merchant-order-save-list", {
        params,
      })
      .then((response) => {
        const data = response.data;
        setMerchantOrderSaveList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id]);

  useEffect(() => {
    getMerchantOrderSaveList();
  }, [getMerchantOrderSaveList]);

  const searchable = merchantOrderSaveList.data.filter((data) => {
    return data.invoice_number.toLowerCase().indexOf(search.toLowerCase()) >= 0;
  });

  const handleOk = () => {
    setConfirmLoading(true);
    setTimeout(() => {
      setArriveDialog(false);
      setConfirmLoading(false);
      handleSetArrivedStatus();
    }, 2000);
  };

  const handleSetArrivedStatus = () => {
    const formdata = new FormData();

    formdata.append("user_id", userData.data.id);
    formdata.append(
      "po_number",
      selectedData !== null ? selectedData.po_number : ""
    );
    formdata.append(
      "po_number_id",
      selectedData !== null ? selectedData.po_number_id : ""
    );

    // setLoadings(true);
    axios
      .post("user/merchant/update-po-into-arrived", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Updated P.O successfully.");
          setTimeout(() => {
            // setLoadings(false);
            getMerchantOrderSaveList();
          }, 1000);
        }
      })
      .catch((error) => {
        console.log("ERROR: ", error);
        // setLoadings(false);
      });
  };

  const handleFilter = (values) => {
    var params = {
      date_from: moment(new Date(values.date_from), "YYYY-MM-DD").format(
        "YYYY-MM-DD"
      ),
      date_to: moment(new Date(values.date_to), "YYYY-MM-DD").format(
        "YYYY-MM-DD"
      ),
      user_id: userData.data.id,
    };
    setLoading(true);
    axios
      .get("user/merchant/filter/merchant-order-save-list", { params })
      .then((response) => {
        const data = response.data;
        rerunNotif("success", "Filter successful.");
        setTimeout(() => {
          setOpenFilterByDate(false);
          setLoading(false);
          setMerchantOrderSaveList({ data, ready: true });
        }, 1000);
      })
      .catch((error) => {
        console.log("Error: ", error);
        // setLoadings(false);
      });
  };

  return (
    <>
      {selectedDisplay === "groupby" && (
        <>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginBottom: 5,
            }}
          >
            <div style={{ flexGrow: 1 }}>
              <Input
                placeholder="Search invoice #"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                style={{
                  border: "2px solid #e5e5e5",
                  width: window.innerWidth < 576 ? "100%" : 300,
                }}
                size="large"
              />
            </div>
            <Tooltip title="Filter by date">
              <Button
                icon={<CalendarOutlined />}
                style={{ marginLeft: 5 }}
                onClick={() => setOpenFilterByDate(true)}
              >
                Filter
              </Button>
            </Tooltip>
            <Tooltip title="Full Details">
              <Button
                type="primary"
                icon={<ArrowRightOutlined />}
                style={{ marginLeft: 5 }}
                onClick={() => setSelectedDisplay("fulldetails")}
              >
                Details
              </Button>
            </Tooltip>
          </div>
          <div style={{ overflowX: "auto" }}>
            <Table
              {...tableProps}
              pagination={{
                position: ["bottomCenter"],
              }}
              columns={tableColumns}
              dataSource={searchable.length > 0 ? searchable : []}
              scroll={scroll}
              rowKey={(record) => record.invoice_number}
            />
          </div>
        </>
      )}

      {selectedDisplay === "fulldetails" && (
        <DeliveryFullDetails close={() => setSelectedDisplay("groupby")} />
      )}

      {openDrawer && (
        <MerchantInvoiceDetails
          open={openDrawer}
          close={() => setOpenDrawer(false)}
          setLoading={setLoading}
          getMerchantOrderSaveList={() => getMerchantOrderSaveList()}
          selectedData={selectedData}
        />
      )}

      <Modal
        title=""
        open={openFilterByDate}
        onCancel={() => setOpenFilterByDate(false)}
        footer={null}
        width={350}
      >
        <Form
          layout="vertical"
          name="basic"
          initialValues={{ remember: false }}
          onFinish={handleFilter}
          autoComplete="off"
        >
          <Space
            direction="vertical"
            style={{ width: "100%", margin: 0, marginTop: 20 }}
          >
            <Form.Item
              name="date_from"
              label="Date From"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <DatePicker
                format={"MM/DD/YYYY"}
                size="large"
                style={{ width: "100%" }}
              />
            </Form.Item>

            <Form.Item
              name="date_to"
              label="Date To"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <DatePicker
                format={"MM/DD/YYYY"}
                size="large"
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Space>

          <Form.Item style={{ marginTop: "20px" }}>
            <Button
              type="primary"
              loading={loading}
              htmlType="submit"
              style={{ width: "100%", borderRadius: "20px" }}
            >
              {loading ? "Loading" : "Filter"}
            </Button>
          </Form.Item>
        </Form>
      </Modal>

      {openDrawerPayment && (
        <MerchantPaymentDetails
          open={openDrawerPayment}
          close={() => setOpenDrawerPayment(false)}
          selectedData={selectedData}
        />
      )}

      <Modal
        title="Are you sure to set status into arrived?"
        open={arriveDialog}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={() => setArriveDialog(false)}
      />
    </>
  );
};

export default MerchantDeliveryFromSupplier;
